import { put, fork, call } from 'redux-saga/effects'
import { takeEveryAndCancel } from './take'
import { fbMe } from '../api'

import {
  FB_LOGIN_AND_ME,
  FB_LOGIN_AND_ME_LOADING,
  FB_LOGIN_AND_ME_FAILURE,
  FB_LOGIN_AND_ME_SUCCESS,
  FB_LOGIN_AND_ME_UNLOAD,
} from '../actions'

function* handleFb() {
  yield put({ type: FB_LOGIN_AND_ME_LOADING })
  try {
    const data = yield call(fbMe)
    yield put({ type: FB_LOGIN_AND_ME_SUCCESS, payload: data })
  } catch (error) {
    yield put({ type: FB_LOGIN_AND_ME_FAILURE, error })
  }
}

export default function* fb() {
  yield fork(
    takeEveryAndCancel,
    FB_LOGIN_AND_ME,
    FB_LOGIN_AND_ME_UNLOAD,
    handleFb
  )
}



// WEBPACK FOOTER //
// ./src/saga/fb.js